import React, { useState, useEffect } from "react";
import Alert from "../../components/Alert";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link } from "react-router-dom";
import { pluck } from "underscore";
import ListSection from "../../components/ListSection";
import DeleteModel from "../../components/DeleteModel";
import labels from "../../constants/Wallet";
import configuration from '../../config';
import { toast } from 'react-toastify';

// List all users
function View({ location }) {
  const columns = [
    {
      title: "ID",
      field: "id",
    },
    { title: "User ID", field: "userid" },
    { title: "Amount Spent ", field: "Amount" },
    { title: "Balance", field: "subtotal" },
  ];
  const [data, setData] = useState([
    { id: '123', userid: '457574', Amount: '$10', subtotal: '$10', },
    { id: '123', userid: '457574', Amount: '$10', subtotal: '$10', },
    { id: '123', userid: '457574', Amount: '$10', subtotal: '$10', },
  ]);

  const btnGroups = [
    { id: 2, title: "Export CSV", type: "exportCSV", path: "/user" },
    { id: 2, title: "Export Excel", type: "exportCSV", path: "/user" },
    { id: 2, title: "Export PDF", type: "exportCSV", path: "/user" },
  ];
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [ids, setIds] = useState([]);

  useEffect(() => {
    // console.log(props.location)
    if (location.state && location.state.is_added) {
      setShow(true)
      setTimeout(
        () => setShow(false),
        3000
      );
    }
    //getDatas();
    // console.log(configuration.baseURL);
  }, [location.state]);

  function getDatas() {
    configuration.getAPI({ url: 'user/list', params: {} }).then((data) => {
      // console.log(data)
      if (data.status === 200) {
        setData(data.payload)
      }
    }).catch(error => {
      // console.log(error)
      return toast.error(error.message)
    });
  }
  function handleAction(type) {
    console.log(type)
    console.log(ids)
    if (ids.length < 1) {
      return toast.error('Please select at least one record')
    } else if (type === 'delete') {
      setShowModal(true);
      return;
    }
    const sendData = {
      ids,
      type: (type === 'makeActive') ? 'active' : (type === 'makeInactive') ? 'inactive' : type
    }
    configuration.postAPI({ url: 'user/action', params: sendData }).then((data) => {
      if (data.status === 200) {
        getDatas()
        setIds([]);
        return toast.success((type === 'delete') ? 'Record deleted successfully' : 'Record update successfully')
      } else if (data.error) {
        return toast.error(data.error.message)
      } else {
        return toast.error('Something went wrong')
      }
    }).catch(error => {
      return toast.error(error.message)
    });
  }
  function handleDelete() {
    const sendData = {
      ids,
      type: 'delete'
    }
    configuration.postAPI({ url: 'user/action', params: sendData }).then((data) => {
      if (data.status === 200) {
        getDatas()
        setIds([]);
        setShowModal(false);
        return toast.success('Record deleted successfully')
      } else if (data.error) {
        return toast.error(data.error.message)
      } else {
        return toast.error('Something went wrong')
      }
    }).catch(error => {
      return toast.error(error.message)
    });
  }
  function handleCancel() {
    setShowModal(false);
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, 'user_id');
    setIds(idArr)
  }

  return (
    <>
      <Breadcrumb module={labels.WalletHistory} />
      <Alert
        show={show}
        setShow={setShow}
        bgColorClass="green"
        caption="Success"
        message="Record added successfully"
      />
      <DeleteModel
        mode={showModal}
        handleDelete={handleDelete}
        handleCancel={handleCancel}
      />
      <ListSection
        captionTitle="View Wallet History"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        csvTitle={"Wallet_History_"}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
      />
    </>
  );
}

export default View;
